import * as $ from 'jquery';

export class WBUtils {

  public static readonly widgetName = 'whiteboard';

  /** HTLM Class names */
  public static readonly whiteboardWidgetClass = '.whiteboardwidget';
  public static readonly canvasPreviewDraggable = 'canvas-preview-draggable';
  public static readonly interactedClass = 'resizedwidget';

  public static readonly fillWrapperClass = '.f-wrapper';
  public static readonly colorWrapperClass = '.c-wrapper';
  public static readonly colorElementClass = '.color-element';
  public static readonly colorHighlighted = 'color-highlighted';

  public static readonly strokeWrapperClass = '.s-wrapper';
  public static readonly strokeRangeID = '#strokeRange';
  public static readonly strokeCircleClass = '.stroke-circle';

  public static readonly selectionContextClass = '.sel-context';

  public static readonly fullScreenButtonClass = '.fullscreenButton';
  public static readonly fsInner = '.fs-inner';

  public static readonly canvasHTML_ID = '#myCanvas';
  public static readonly renderCanvasHTML_ID = '#renderCanvas';
  public static readonly dynamicCanvasHTML_ID = '#dynamicCanvas';
  public static readonly draggableImageClass = 'draggableimage';
  public static readonly dropZoneTarget = '.canvas-dropzone';
  public static readonly dropZoneAccept = `img:not(.dragPreview), .${WBUtils.draggableImageClass}, .dragfromgallery`;
  public static readonly galleryWidgetClass = 'gallerywidget';
  public static readonly taskDataAttr = 'data-taskcardid';
  public static readonly storyDataAttr = 'data-userstoryid';
  public static readonly whiteboardDropZoneClass = '.whiteboarddropzone';
  public static readonly galleryDropIndicator = '.gallery-drop-indicator';
  public static readonly colorIconClass = '.colorIcon';
  public static readonly fillIconClass = '.fillIcon';
  public static readonly canvasWrapperClass = '.canvas-wrapper';
  public static readonly widgetClass = '.widget';
  public static readonly widgetTitleClass = '.widget-title';
  public static readonly historyWrapperClass = '.history-wrapper';
  public static readonly historyElementsClass = '.history-elements';
  public static readonly historyElementImgAndParagraphClass = '.h-elem img, .h-elem img';
  public static readonly historyElementDivClass = '.h-elem img';

  public static readonly labelButtonClass = '.label-button';
  public static readonly labelButtonSelectedClass = '.label-button-selected';

  public static readonly dropTarget = 'droptarget';
  public static readonly widgetResizerClass = '.widget-resizer';

  public static buttonSelect = '#btn-select';
  public static buttonFreeHand = '#btn-free';
  public static buttonBasic = '#btn-basic';
  public static buttonAdvanced = '#btn-advanced';

  /** JQuery objects */
  public static whiteboardWidget: any;
  public static canvasPreview: any;
  public static canvasDraggable: any;
  public static canvasContainer: any;
  public static canvasDropZone: any;
  public static toolButton: any;
  public static widgetResizer: any;
  public static buttonWrapper: any;
  public static spinnerWrapper: any;
  public static closePreviewBtn: any;
  public static downloadLinkHolder: any;
  public static pmsInner: any;
  public static pmsInnerAdvanced: any;
  public static canvasHoverPanel: any;
  public static whiteboardStateLabel: any;
  public static saveHintElement: any;

  /**
     * Initializes the JQuery-objects after the view is built.
     */
  public static initJQuerySelectorsAfterInit() {
    this.widgetResizer = $(this.widgetResizerClass);
    this.whiteboardWidget = $(this.whiteboardWidgetClass);
    this.canvasPreview = $('.canvas-preview');
    this.canvasDraggable = $('.canvas-draggable');
    this.toolButton = $('.toolButton');
    this.buttonWrapper = $('.button-wrapper');
    this.spinnerWrapper = $('.spinner-wrapper');
    this.canvasContainer = $('.canvas-container');
    this.canvasDropZone = $('.canvas-dropzone');
    this.closePreviewBtn = $('.closePreview');
    this.downloadLinkHolder = $('.downloadLinkHolder');
    this.pmsInner = $('.pms-inner');
    this.pmsInnerAdvanced = $('.pms-inner-ms');
    this.canvasHoverPanel = $('.canvas-hover');
    this.whiteboardStateLabel = $('.wbStateLabel');
    this.saveHintElement = $('.save-hint');
  }

}
